/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Subscription_Conflict_TitleInputs */

const en_dialog_subscription_conflict_title = /** @type {(inputs: Dialog_Subscription_Conflict_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription Conflict`)
};

const ar_dialog_subscription_conflict_title = /** @type {(inputs: Dialog_Subscription_Conflict_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعارض في الاشتراك`)
};

const de_dialog_subscription_conflict_title = /** @type {(inputs: Dialog_Subscription_Conflict_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnementkonflikt`)
};

const es_dialog_subscription_conflict_title = /** @type {(inputs: Dialog_Subscription_Conflict_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conflicto de suscripción`)
};

const fr_dialog_subscription_conflict_title = /** @type {(inputs: Dialog_Subscription_Conflict_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conflit d'abonnement`)
};

const it_dialog_subscription_conflict_title = /** @type {(inputs: Dialog_Subscription_Conflict_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conflitto di abbonamento`)
};

const ja_dialog_subscription_conflict_title = /** @type {(inputs: Dialog_Subscription_Conflict_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サブスクリプションの競合`)
};

const ko_dialog_subscription_conflict_title = /** @type {(inputs: Dialog_Subscription_Conflict_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구독 충돌`)
};

const pt_br_dialog_subscription_conflict_title = /** @type {(inputs: Dialog_Subscription_Conflict_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conflito de assinatura`)
};

const ru_dialog_subscription_conflict_title = /** @type {(inputs: Dialog_Subscription_Conflict_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Конфликт подписки`)
};

const th_dialog_subscription_conflict_title = /** @type {(inputs: Dialog_Subscription_Conflict_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อมูลการสมัครสมาชิกขัดแย้งกัน`)
};

const tr_dialog_subscription_conflict_title = /** @type {(inputs: Dialog_Subscription_Conflict_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonelik Çakışması`)
};

const zh_cn_dialog_subscription_conflict_title = /** @type {(inputs: Dialog_Subscription_Conflict_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 会员已绑定其他帐号`)
};

const zh_tw_dialog_subscription_conflict_title = /** @type {(inputs: Dialog_Subscription_Conflict_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`訂閱已綁定其他帳號`)
};

/**
* | output |
* | --- |
* | "Subscription Conflict" |
*
* @param {Dialog_Subscription_Conflict_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_subscription_conflict_title = /** @type {((inputs?: Dialog_Subscription_Conflict_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Subscription_Conflict_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_subscription_conflict_title(inputs)
	if (locale === "ar") return ar_dialog_subscription_conflict_title(inputs)
	if (locale === "de") return de_dialog_subscription_conflict_title(inputs)
	if (locale === "es") return es_dialog_subscription_conflict_title(inputs)
	if (locale === "fr") return fr_dialog_subscription_conflict_title(inputs)
	if (locale === "it") return it_dialog_subscription_conflict_title(inputs)
	if (locale === "ja") return ja_dialog_subscription_conflict_title(inputs)
	if (locale === "ko") return ko_dialog_subscription_conflict_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_subscription_conflict_title(inputs)
	if (locale === "ru") return ru_dialog_subscription_conflict_title(inputs)
	if (locale === "th") return th_dialog_subscription_conflict_title(inputs)
	if (locale === "tr") return tr_dialog_subscription_conflict_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_subscription_conflict_title(inputs)
	return zh_tw_dialog_subscription_conflict_title(inputs)
});